import { auth, googleProvider } from "@/lib/firebase";
import { signInWithPopup, signOut } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";

async function updateHeatmapOnLogin(userId: string) {
  const rec = await fetchUserLocation(userId);
  if (!rec || rec.last_lat == null || rec.last_lng == null) return;
  const newGh = encodeGeohash(rec.last_lat, rec.last_lng);
  if (rec.last_geohash === newGh) return;
  await upsertHeatmapIncrement(rec.last_geohash, newGh);
  await updateUserGeohash(userId, newGh);
}

// Call after successful Firebase auth
async function adjustHeatmapAfterLogin() {
  try {
    const fn = httpsCallable(getFunctions(), "heatmapAdjustOnLogin");
    await fn();
  } catch (e) {
    if (import.meta.env.DEV) console.warn("heatmapAdjustOnLogin failed", e);
  }
}

export function SignIn() {
  return (
    <div className="flex gap-3">
      <button
        className="btn-pixel btn-pixel-primary"
        onClick={() => signInWithPopup(auth, googleProvider)}
      >
        Sign in with Google
      </button>
      <button
        className="btn-pixel btn-pixel-secondary"
        onClick={() => signOut(auth)}
      >
        Sign out
      </button>
    </div>
  );
}

// Call updateHeatmapOnLogin after successful authentication
// e.g. inside your existing login success branch:
// await updateHeatmapOnLogin(authenticatedUser.id);

// After you confirm login success:
// await adjustHeatmapAfterLogin();

